var map = {
	"./black/guaduan.png": "FvKL",
	"./blue/guaduan.png": "IfHg",
	"./white/guaduan.png": "e7Kc"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2sS";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom ^\.\/.*\/guaduan\.png$
// module id = d2sS
// module chunks = 24